// extracted by mini-css-extract-plugin
module.exports = {"iframe":"iframe_iframe__kK68Y"};